<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired}">
    <div class="label" :style="labelStyle">{{itemSetting.action.label[activeLang]}}</div>
    <div class="btn btnFull"
      @focusout="updateCITE(item)">
      <CITEditor
        :model="item.value"
        :toolbarOption="textOption"
        :lang="activeLang" />
    </div>
  </div>
</template>

<script>
import CITEditor from '@/components/CITEditor/Index.vue'
import UTIL from '@/common/util'

export default {
  name: 'CertModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting'
  ],
  components: {
    CITEditor
  },
  computed: {
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    }
  },
  data () {
    return {
      textOption: [
        'Bold', 'Italic', 'Underline', 'Strikethrough',
        'FontSize', 'FontFamily',
        'Color', 'BackgroundColor',
        'TextAlign'
      ]
    }
  },
  methods: {
    updateCITE (target) {
      const html = target.value[this.activeLang]
      if (this.isNew) {
        Object.keys(target.value).forEach(function (lang) {
          target.value[lang] = html
        })
      }
      const fillValue = UTIL.fillLangs(target.value, target.value[this.activeLang])
      target.value = fillValue
    },
    setDetailStyle (detailData) {
      const notStyles = ['options']
      const styles = Object.keys(detailData).filter(function (o) {
        return notStyles.indexOf(o) === -1
      })
      const styleObj = {}
      styles.forEach(function (x) {
        const obj = detailData[x]
        let key = ''
        let value = ''
        switch (x) {
          case 'background':
            Object.keys(obj).forEach(function (o) {
              key = `${x}-${o}`
              value = obj[o]
              styleObj[key] = value
            })
            break
          case 'border':
            styleObj['border-width'] = '1px'
            Object.keys(obj).forEach(function (o) {
              key = `${x}-${o}`
              value = obj[o]
              styleObj[key] = value
            })
            break
          case 'text':
            styleObj.color = obj.color
            break
        }
      })
      return styleObj
    }
  }
}
</script>
